import {Router} from '@angular/router';
import {Injectable, isDevMode, OnInit, EventEmitter} from '@angular/core';
import {Observable, BehaviorSubject, EMPTY} from 'rxjs';
import {Subscription} from 'rxjs/Subscription';

import {map} from 'rxjs/operators';
import {HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpHandler, HttpRequest} from '@angular/common/http';
import {Md5} from 'ts-md5/dist/md5';
import {TokenStoreService} from './auth/token-store.service';


@Injectable()
export class GlobalService implements OnInit {

  readonly defaultLogOutState: {
    LoginStatus: boolean;
    Log: string;
    LoginName: string;
    UnterschriftName: string;
    UnterschriftTitel: string;
    Admin: boolean;
    Passwort: string;
    PasswortMD5: string;
    DBScope: string;
  } = {
      "LoginStatus": false,
      "Log": "",
      "LoginName": "",
      "UnterschriftName": "",
      "UnterschriftTitel": "",
      "Admin": false,
      "Passwort": "",
      "PasswortMD5": "",
      "DBScope": "DB_Pasura"
    };

  APPLICATION = "PASURA";
  BACKENDBASE = "/api";
  ClientVersionText = '2026-06-02 19:56';

  headers: Headers;
  runstatus = "";
  polDaten: any;  /*für Schadenfall-componente-*/
  progressSpinner = false;

  private pasuraAction: BehaviorSubject<String>;

  readonly LogOut = Object.freeze({...this.defaultLogOutState});

  Login = this.getLogOutState();

  Settings = {
    "PrintLogo": true

  };

  formatter = new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: 'CHF',
    minimumFractionDigits: 2
  });


  tarifePasura: any[];
  tarifPferd;
  tarifRindvieh;
  RGJahr;

  kontakt: any;
  policen: [any];
  salutation = [];
  anzSchadenfaelle = 0;

  changeKontakt = new EventEmitter();
  subsVar: Subscription;
  AntragPferd: any;


  constructor(private router: Router, private http: HttpClient, private tokenStore: TokenStoreService) {


    this.pasuraAction = new BehaviorSubject<any>("");
    this.headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});

    var s = JSON.parse(localStorage.getItem("PasuraSettings"));

    console.log("Settings ->" + JSON.stringify(s));
    console.log(s != undefined && s.PrintLogo != undefined);
    if (s != undefined && s.PrintLogo != undefined) {
      this.Settings = s;
    }

    if (this.checkToken()) {
      console.log("ReLogin form refreshToken ");
      this.getTarife();
      this.loadSalutation();
      this.router.navigate(['/pasura']);

    } else {
      this.Login = this.getLogOutState();
    }

    console.log("isDevMode -> " + isDevMode());

    const host = window.location.href;

    if (host.includes("test.") || host.includes("test-") || host.includes("localhost") || host.includes("192.168.60")) {
      this.serverLog("Host -> " + host);

      this.Login.DBScope = "DB_Pasura_Test";
      this.Login.LoginName = "Maurus";
      this.Login.Passwort = "fantasy1";
      //this.Login.DBScope="DB_Pasura";
    }

    console.log("DBScope= " + this.Login.DBScope);
  }

  getLogOutState() {
    return {...this.defaultLogOutState};
  }


  checkToken() {
    var request = new XMLHttpRequest();
    var token = sessionStorage.getItem("PasuraRefreshToken");

    console.log("checkToken ->" + token);

    if (token == undefined || token == null || token.length < 5) {
      return false;
    }


    request.open('POST', "/api/v1/CheckToken", false);  // `false` makes the request synchronous
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.send();


    if (request.status !== 200) {
      return false;
    }

    const result = JSON.parse(request.responseText);
    result.RefreshToken = token;
    this.Login = result.Login;
    this.tokenStore.setJwtToken(result.Login.JWT);

    return result.Status === 'OK';
  }


  getPasuraAction(): Observable<any> {
    return this.pasuraAction.asObservable();
  }

  setPasuraAction(newValue): void {
    this.pasuraAction.next(newValue);
  }

  setLogOut() {
    console.log("setLogOut -> ", this.LogOut);
    this.Login = this.getLogOutState();

    if (isDevMode()) {
      this.Login.LoginName = "maurus";
      this.Login.Passwort = "fantasy1";
      this.Login.DBScope = "DB_Pasura_Test";
    } else {
      this.Login.Passwort = "";
    }
    this.headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});

    this.tokenStore.clearJwtToken();
    this.tokenStore.clearRefreshToken();
    localStorage.removeItem("PasuraLogin");

    //this.policen = [];
    this.setPasuraAction('LogOut');
    this.router.navigate(['/login']);
    this.anzSchadenfaelle = 0;
  }


  ngOnInit() {
    console.log("Globserv OnInit");

  }

  startApp() {
    if (isDevMode()) {
      console.log("StartApp");
      //this.setPasuraAction('loadContact;20007');
    }
  }


  getBackendData(resturi: string, data: any) {
    return this.http.post<any>(this.BACKENDBASE + resturi, data).pipe(map(res => res));
  }


  formatMoney(d) {
    return this.formatter.format(d);
  }

  formatDate(d) {

    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    var year = d.getFullYear();
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var seconds = d.getSeconds();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    if (hours.length < 2) {
      hours = '0' + hours;
    }

    if (minutes.length < 2) {
      minutes = '0' + minutes;
    }

    if (seconds.length < 2) {
      seconds = '0' + seconds;
    }

    return [year, month, day, hours, minutes, seconds].join('.');
  }

  getJsonDate(d: Date) {

    //var datum =  d.getFullYear() ;
      var datum = d.getFullYear() + "-";
    if ((d.getMonth() + 1) < 10) {
      datum = datum + "0";
    }
    datum = datum + (d.getMonth() + 1) + "-";
    if (d.getDate() < 10) {
      datum = datum + "0";
    }
    datum = datum + d.getDate();
    console.log("Datum -> " + datum);

    return datum;
  }

  getIsDevMode() {
    return isDevMode();
  }

  getTarife(tarifGen = '2025') {
    console.log("getTarife");
    var resultData;
    this.getBackendData("/v1/getTarifStruktur?TarifGen=" + tarifGen, {}).subscribe(
      result => resultData = result,

      err => {
        console.log("Error");
        this.setPasuraAction({"msg": {"title": "Fehlmeldung", "txt": "Tarifstruktur konnte nicht geladen werden!"}});
      },
      () => {
        if (resultData.hasOwnProperty("Tarife")) {
          //console.log(JSON.stringify(resultData));
          this.tarifePasura = resultData.Tarife;
          this.tarifPferd = this.tarifePasura.filter(function(prod) {return prod.TarifID == "Pferd";})[0];
          this.tarifRindvieh = this.tarifePasura.filter(function(prod) {return prod.TarifID == "Rindvieh";})[0];
          this.RGJahr = resultData.RGJahr;
          console.log("TarifGen=> " + this.tarifPferd.TarifGen);

          //console.log("RechungsJahr=" +this.RGJahr );
        }
      }
    );
  }

  loadSalutation() {

    var data = {};

    var resultData;
    this.getBackendData("/v1/getSalutation", data).subscribe(
      result => resultData = result,

      err => {
        this.setPasuraAction({"msg": {"title": "Fehlmeldung", "txt": "Anreden konnte nicht geladen werden!"}});
        console.log("Anreden konnte nicht geladen werden!")
        this.router.navigate(['/logout']);
      },
      () => {
        //console.log(JSON.stringify(resultData));
        this.salutation = resultData;
      }
    );
  }

  getOptionen(p) {
    var keys = Object.keys(p);
    var opt = [];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (p[key].hasOwnProperty('VArt') && p[key].VArt == 'Option') {
        opt.push(p[key]);
      }
    }
    return opt;
  }

  getHauptPositionen(p) {
    var keys = Object.keys(p);
    var hv = [];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (p[key].hasOwnProperty('VArt') && p[key].VArt == 'HV') {
        hv.push(p[key]);
      }
    }
    return hv;
  }

  doChangeKontakt() {
    this.changeKontakt.emit();
  }

  getTimeStampString(): string {
    var d = new Date();
    var mo = this.addZero(d.getMonth() + 1);
    var yr = this.addZero(d.getFullYear());
    var dt = this.addZero(d.getDate());
    var h = this.addZero(d.getHours());
    var m = this.addZero(d.getMinutes());
    var s = this.addZero(d.getSeconds());

    return (yr + '_' + mo + '_' + dt + '_' + h + "_" + m + "_" + s);
  }

  addZero(i: number) {
    if (i < 10) {
      return "0" + i;
    }
    return i;
  }




  serverLog(text: string) {
    console.log("ServerLog-> " + text);
    var data = {"Text": text};

    var resultData;

    this.getBackendData("/v1/serverLog", data).subscribe(
      result => resultData = result,
      err => {
        console.log("Error");
        console.log(err);
      },
      () => {}
    );
  }

  getSex(s: any) {
    var sex = s;

    switch (s) {
      case 'S':
        sex = 'Stute';
        break;

      case 'H':
        sex = 'Hengst';
        break;


      case 'W':
        sex = 'Wallach';
        break;
    }

    return sex;
  }

  getZW(i: any) {
    var zw = 'jährlich';

    switch (i) {
      case 12:
        zw = 'monatlich';
        break;

      case 4:
        zw = 'quartalsweise';
        break;


      case 2:
        zw = 'halbjährlich';
        break;
    }

    return zw;
  }

}
